/*
 * This work has been created or enhanced by
 *   Markus Luckey, 2025, KERNBLICK GmbH
 *
 * This file is covered by the EU PL 1.2 license.
 * You may obtain a copy of the licence at
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 */

import { createRouter, createWebHistory } from 'vue-router';

import Mgr from '@/services/SecurityService';
let mgr = new Mgr();

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Home.vue'),
    meta: {
      requiresAuth: false
    },
  },
  {
    path: '/app/:id',
    name: 'Apps',
    props: true,
    component: () => import(/* webpackChunkName: "Apps" */ '@/views/Apps.vue'),
    meta: {
      requiresAuth: true,
      // role: [EnvProvider.value('OIDC_ADMIN_ROLE')]
    },
  },
  {
    path: '/accessdenied',
    name: 'AccessDenied',
    component: () => import(/* webpackChunkName: "AccessDenied" */ '@/components/AccessDenied.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/debug',
    name: 'Debug',
    component: () => import(/* webpackChunkName: "Debug" */ '@/components/Debug.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/callback',
    name: 'Callback',
    component: () => import(/* webpackChunkName: "Callback" */ '@/views/Callback.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName: "Logout" */ '@/views/Logout.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/loggedout',
    name: 'LoggedOut',
    component: () => import(/* webpackChunkName: "LoggedOut" */ '@/views/LoggedOut.vue'),
    meta: {
      requiresAuth: false
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  console.debug('To: ' + to.path);
  console.debug('Requires auth: ' + requiresAuth);
  if (requiresAuth && mgr) {
    mgr.getRoles().then(
      roles => {
        if (roles) {
          // @ts-ignore
          let intersection = to.meta.role ? roles.filter(x => to.meta.role.includes(x)) : ['pass'];
          if (intersection.length > 0){
            next();
          } else {
            next('/accessdenied');
          }
        } else {
          console.info('User not logged in, no roles found.');
          next('/accessdenied');
        }
      },
      err => {
        console.error(err);
      }
    );
  } else {
    console.debug('Authorization is disabled or not required. Proceeding without authentication.');
    next();
  }
});

export default router;
